export default "__VITE_ASSET__BfQRxj0B__"